<template>
	<Row class="items-center">
		<component :is="item.iconComponent" class="nav-button-icon" />
		<component
			v-if="collapsedMode && item.suffixComponent && shouldAlwaysShow"
			class="suffix-component-container"
			:is="item.suffixComponent"
			v-bind="item.suffixComponentProps"
			:class="{ ...(item.suffixComponentClass || {}), 'absolute-suffix': true }"
		/>
		<template v-else>
			<div class="nav-text">{{ item.title }}</div>
			<component
				class="suffix-component-container"
				:is="item.suffixComponent"
				v-if="item.suffixComponent"
				v-bind="item.suffixComponentProps"
				:class="item.suffixComponentClass"
			/>
		</template>
	</Row>
</template>

<script>
import AppTooltip from '@/components/common/AppTooltip';
export default {
	name: 'NavigationButton',
	components: { AppTooltip },
	props: {
		item: { type: Object },
		collapsedMode: { type: Boolean, default: true },
	},
	computed: {
		shouldAlwaysShow() {
			return Object.keys(this.item.suffixComponentClass).some((className) => className === 'always-show');
		},
	},
};
</script>

<style scoped lang="scss">
.navigation-buttons {
	$in-transition-time: 0.1s;
	$out-transition-time: 0.1s;

	.nav-btn {
		position: relative;
		display: flex;
		align-items: center;
		height: 30px;
		color: #4d4c52;
		border-radius: 7px;
		text-decoration: none;
		margin: 4px 8px;
		padding: 7px 5px;

		color: var(--Colors-Neutral-Text-colorTextSecondary, #646e87);
		font-size: 13px;
		font-weight: 400;

		> * {
			z-index: 0;
		}
		.nav-button-icon {
			margin-right: 10px;
			width: 16px;
			height: 16px;
		}

		.nav-text {
			font-size: 14px;
			&.user-mode {
				font-size: 14px !important;
			}
		}
		&:hover {
			background: rgba(128, 128, 128, 0.1);
		}
		&:before {
			position: absolute;
			top: 0;
			left: 0;
			content: '';
			height: 100%;
			width: 100%;
			border-radius: 6px;
			background: rgba(255, 255, 255, 0.2);
			opacity: 0;
		}

		&.router-link-active {
			::v-deep {
				svg,
				path,
				rect,
				line {
					fill: black;
				}
			}
			color: #1b1c21;
			font-size: 13px;
			font-weight: 400;
			transition: $in-transition-time;
			background: #e7e8f9 !important;

			&:before {
				opacity: 1;
				transition: $in-transition-time;
			}
		}
		&:hover {
			background: #e7e8f980;
			&:before {
				transition: $in-transition-time;
				opacity: 0.7;
			}
		}
		&:not(:hover),
		:not(.router-link-active):not(:hover) {
			transition: $out-transition-time;

			&:before {
				transition: $out-transition-time;
			}
		}

		&:not(.router-link-active) {
			transition: $out-transition-time;
			::v-deep {
				svg,
				path,
				rect,
				line {
					fill: #6c7395;
				}
			}
		}
	}
}
.suffix-component-container {
	opacity: 0;
	transition: 0.2s;
	&.always-show {
		opacity: 1;
	}
	&.absolute-suffix {
		top: 1px;
		left: 2px;
		position: absolute;
	}
}
.navigation-separator {
	border-bottom: 1px solid var(--border-color);
}
</style>
